module.exports = __webpack_public_path__ + "ea43d7cfd17036b85dede5e4e01adb8e.svg";